import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ThesisPrintStatus } from "@/lib/api/bindery";

const STEPS: { status: ThesisPrintStatus; label: string }[] = [
  { status: "SUBMITTED", label: "Submitted" },
  { status: "FORMAT_CHECK", label: "Format Check" },
  { status: "APPROVED", label: "Approved" },
  { status: "PRINTING", label: "Printing" },
  { status: "BINDING", label: "Binding" },
  { status: "READY", label: "Ready" },
  { status: "COLLECTED", label: "Collected" },
];

const TERMINAL: ThesisPrintStatus[] = ["REJECTED", "CANCELLED"];

export function ThesisStatusStepper({ status }: { status: ThesisPrintStatus }) {
  if (TERMINAL.includes(status)) {
    return (
      <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-900">
        Request {status === "REJECTED" ? "rejected" : "cancelled"}.
      </div>
    );
  }

  const currentIndex = STEPS.findIndex((s) => s.status === status);

  return (
    <ol className="flex flex-wrap items-center gap-y-3">
      {STEPS.map((step, idx) => {
        const complete = idx < currentIndex;
        const active = idx === currentIndex;
        return (
          <li key={step.status} className="flex items-center gap-2">
            <div
              className={cn(
                "flex h-7 w-7 items-center justify-center rounded-full border text-xs font-semibold transition-all duration-300",
                complete && "border-emerald-500 bg-emerald-500 text-white",
                active && "scale-110 border-blue-600 bg-blue-600 text-white shadow-md",
                !complete && !active && "border-slate-300 bg-white text-slate-500"
              )}
            >
              {complete ? <Check className="h-4 w-4" /> : idx + 1}
            </div>
            <span
              className={cn(
                "text-xs font-medium transition-colors",
                active ? "text-slate-900" : complete ? "text-emerald-700" : "text-slate-500"
              )}
            >
              {step.label}
            </span>
            {idx < STEPS.length - 1 && (
              <span
                className={cn(
                  "mx-2 hidden h-px w-8 transition-colors sm:block",
                  complete ? "bg-emerald-400" : "bg-slate-200"
                )}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
